import {
	AccountCircle,
	AccountCircleTwoTone,
	Logout,
	LogoutTwoTone,
} from "@mui/icons-material";
import { IconButton, Menu, styled, useTheme } from "@mui/material";
import { hoverActiveStyles, hoverStyles } from "helpers/hoverStyles";
import { signOutEverywhere } from "helpers/signOutEverywhere";
import { useAuthStatus } from "helpers/useAuthStatus";
import React from "react";
import { routes } from "routes";
import { NavBarAccountMenuItem } from "./NavBarAccountMenuItem";
import { useKeycloak } from "@react-keycloak/web";

const StyledMenu = styled(Menu)(({ theme }) => ({
	"& .MuiMenu-paper": {
		backgroundColor: theme.palette.primary.main,
	},
}));

export const NavBarAccountMenu = (): JSX.Element => {
	const theme = useTheme();
	const { setRole } = useAuthStatus();
	const { keycloak } = useKeycloak();

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (): void => {
		setAnchorEl(null);
	};

	const onSignOut = (): void => {
		signOutEverywhere(keycloak, setRole);
	};

	return (
		<div>
			<IconButton
				sx={!anchorEl ? hoverStyles(theme) : hoverActiveStyles()}
				aria-label="Account menu"
				aria-controls="menu-appbar"
				aria-haspopup="true"
				onClick={handleClick}
				color="inherit"
				size="large"
			>
				<AccountCircle />
			</IconButton>

			<StyledMenu
				id="customized-menu"
				anchorEl={anchorEl}
				keepMounted
				open={!!anchorEl}
				onClose={handleClose}
				elevation={0}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				<NavBarAccountMenuItem
					href={routes._.people._.me.path}
					icons={{ filled: AccountCircle, outlined: AccountCircleTwoTone }}
					onClick={handleClose}
				>
					Profile
				</NavBarAccountMenuItem>

				<NavBarAccountMenuItem
					onClick={onSignOut}
					icons={{ filled: Logout, outlined: LogoutTwoTone }}
				>
					Sign out
				</NavBarAccountMenuItem>
			</StyledMenu>
		</div>
	);
};
